import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState = 'accounts'

const selectedTabSlice = createSlice({
    name: 'selected-tab',
    initialState,
    reducers: {
  
      setSelectedTab: (state,action:PayloadAction<string>) => {
  
        return (state = action.payload)
        
      },
  
    }
    
});
  
// Reducer
export default selectedTabSlice.reducer;

// Actions
export const {setSelectedTab} = selectedTabSlice.actions;